export const tipsType = {
  info: 'info',
  warning: 'warning',
  success: 'success',
  error: 'error'
}